export const TEST_ID = 'serviceLogEntry';

export const META_SEPARATOR = ' · ';

export const TITLE_SEPARATOR = ' — ';
